document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("header");
  const tpKv = document.querySelector(".tp-kv");
  const logoImg = document.querySelector(".l-header__logo img");

  if (!header || !tpKv || !logoImg) return; // 要素がない場合は処理しない

  function checkScroll() {
    const tpKvHeight = tpKv.clientHeight; // .tp-kv の高さを取得
    const scrollY = window.scrollY; // 現在のスクロール量

    if (scrollY > tpKvHeight) {
      header.classList.remove("is-toppage"); // クラス削除
    } else {
      header.classList.add("is-toppage"); // クラス追加
    }
  }

  window.addEventListener("scroll", checkScroll);
  checkScroll(); // 初回チェック (リロード時に適用)
});
